import React from 'react'

const Footer = () => {
  return (
    <div className='my-4 text-center'>React Form Testing &copy; 2026</div>
  )
}

export default Footer